export default {
    computed: {

        membershipTypeData() {
            return this.$store.state.application.membershipTypeData
        },

        applicationData() {
            return this.$store.state.application.applicationData
        },

        formSelectChoices() {
            return this.$store.state.application.formSelectChoices
        },

        membershipTypeIsLoaded() {
            return this.$store.state.application.membershipTypeIsLoaded
        },

        applicationFinishedSuccessful() {
            return this.$store.state.application.applicationFinishedSuccessful
        },

        freeOfCharge() {
            return this.$store.getters['application/freeOfCharge']
        },

        externalRedirectUrl() {
            return this.$store.state.application.externalRedirectUrl
        },
    },

    methods: {
        /////////////////////////////////////////////////
        //Mutations
        /////////////////////////////////////////////////

        setApplicationProp(prop, value, path = null) {
            this.$store.commit('application/setApplicationProp', {prop, value, path})
        },

        setMembershipTypeData(membershipType) {
            this.$store.commit('application/setMembershipTypeData', membershipType)
        },

        setFundraiserData(fundraiser) {
            this.$store.commit('application/setFundraiserData', fundraiser)
        },

        setExternalHandover(handover) {
            this.$store.commit('application/setExternalHandover', handover)
        },

        setMembershipTypeIsLoaded(loaded) {
            this.$store.commit('application/setMembershipTypeIsLoaded', loaded)
        },

        discardMembershipTypeData() {
            this.$store.commit('application/discardMembershipTypeData')
        },

        discardApplicationData() {
            this.$store.commit('application/discardApplicationData')
        },

        resetFeeSelection() {
            return this.$store.commit('application/resetFeeSelection')
        },


        /////////////////////////////////////////////////
        //Actions
        /////////////////////////////////////////////////
        fetchMembershipTypeData(membershipTypeId, fundraiser) {
            return this.$store.dispatch('application/fetchMembershipTypeData', {membershipTypeId, fundraiser})
        },

        sendApplication(fundraiser = null) {
            return this.$store.dispatch('application/sendApplication', fundraiser)
        },

        fetchDonorInformation(donorHint) {
            return this.$store.dispatch('application/fetchDonorInformation', donorHint)
        },
    }
}
